import { toRFC3339UTC } from './geohashUtil';

const now = Date.now();

export const SEED_COMMENTS = [
  {
    id: 1,
    thread_id: 1,
    parent_comment_id: null,
    depth: 1,
    author_user_id: 1002,
    body: 'Same here, 20 min wait.',
    deleted_at: null,
    created_at: toRFC3339UTC(new Date(now - 3600000)),
    updated_at: toRFC3339UTC(new Date(now - 3600000)),
    edited_at: null,
  },
  {
    id: 2,
    thread_id: 1,
    parent_comment_id: null,
    depth: 1,
    author_user_id: 1003,
    body: 'Try the side entrance.',
    deleted_at: null,
    created_at: toRFC3339UTC(new Date(now - 1800000)),
    updated_at: toRFC3339UTC(new Date(now - 1800000)),
    edited_at: null,
  },
  {
    id: 3,
    thread_id: 4,
    parent_comment_id: null,
    depth: 1,
    author_user_id: 1001,
    body: 'Amazing energy!',
    deleted_at: null,
    created_at: toRFC3339UTC(new Date(now - 7200000)),
    updated_at: toRFC3339UTC(new Date(now - 7200000)),
    edited_at: null,
  },
  {
    id: 4,
    thread_id: 10,
    parent_comment_id: null,
    depth: 1,
    author_user_id: 1009,
    body: 'Reproduced on iOS 18.',
    deleted_at: null,
    created_at: toRFC3339UTC(new Date(now - 900000)),
    updated_at: toRFC3339UTC(new Date(now - 900000)),
    edited_at: null,
  },
];
